import React from "react";
import { Box, Typography } from "@mui/material";
import ExpenseReportGenerator from "../components/ExpenseReportGenerator";

const ExpenseReportPage: React.FC = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Box>
        <Typography variant="h4" gutterBottom>
          Relatório de Despesas
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Gere relatórios detalhados das suas despesas.
        </Typography>
      </Box>
      <ExpenseReportGenerator />
    </Box>
  );
};

export default ExpenseReportPage;
